import { lazy } from 'react';

const Simulator = lazy(() => import(/* webpackChunkName: "simulator" */ './Container'));

export default Simulator;
